export default "__VITE_ASSET__BpwChjjM__"